import * as React from 'react';
import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Flexbox = (props: BoxProps) => <Box {...props} display="flex" />;

export const centeredFlex = `
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CenteredFlex = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const colCenteredFlex = `
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ColCenteredFlex = styled('div')`
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const vCenteredFlex = `
    display: flex;
    align-items: center;
`;

export const VCenteredFlex = styled('div')`
    display: flex;
    align-items: center;
`;

export const VStartFlex = styled('div')`
    display: flex;
    align-items: flex-start;
`;

export const RightFlex = styled('div')`
    display: flex;
    align-items: center;
    justify-content: left;
`;
